
/**
 * 주문 타입
 */
export type GetOrderById200OrderType = typeof GetOrderById200OrderType[keyof typeof GetOrderById200OrderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrderById200OrderType = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  ONE_TIME: 'ONE_TIME',
} as const;
